import { companyMemory } from "../../Objects/Memory/Memory"

export const handleInvalid = (message: string) => (e: React.FormEvent<HTMLInputElement>) => {
  e.currentTarget.setCustomValidity(message)
}

export const handleChangeClearInvalid =
  (onChange: (e: React.ChangeEvent<HTMLInputElement>) => void) => (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.setCustomValidity("")
    onChange(e)
  }

export const getWhatsappSupportMessage = (orderId: number) => {
  const template =
    companyMemory.companySocialMediaEntity?.whatsappOrderSupportMessageTemplate ||
    "Olá! Gostaria de informações do pedido #{{orderId}}."

  return template.split("{{orderId}}").join(`${orderId}`)
}

export const getWhatsappSupportLink = (orderId: number, whatsappPhone: string) => {
  const encodedMessage = encodeURIComponent(getWhatsappSupportMessage(orderId))
  return `https://wa.me/${whatsappPhone}?text=${encodedMessage}`
}
